





















































































import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {Company, CompanyAccount, DateTime} from "../../modules/models";
import UserRequired from "../UserRequired";
import rd from "@/modules/vRoutedefs";
import SuperSheet from "@/components/shared/SuperSheet.vue";
import {hasIosAppInterface} from "@/modules/utils";
import {NativeApi} from "@/modules/NativeBridge";

@Component({
    components: {
        "at-super": SuperSheet
    }
})
export default class CompanyPage extends UserRequired {
    @Inject()
    api!: Api;
    @Inject()
    nativeApi!: NativeApi;

    get company(): Company | null {
        return this.baseApi.company;
    }
    get customerRef(): number | null {
        return this.baseApi.customerRef;
    }
    search: string = "";

    headers = [
        {text: "Navn", value: "name"},
        {text: "Organisasjonsnr", value: "orgNum"},
        {text: "", value: "", align: "right", sortable: false}
    ];
    userCompanies: Company[] = [];

    get companyOrgNum(): number | null {
        return this.company && this.company.orgNum || null;
    }

    async chooseCompany(orgnum: number) {
        if(orgnum != this.companyOrgNum) {
            try {
                await this.api.setDefaultLoginCompany(orgnum);
                await this.$router.push({query: {orgnum: `${orgnum}`}});
            } catch (err) {
                this.emitError(err);
            }
        }
    }

    // If user hits enter in search box and there is exactly one result in the list, choose it.
    chooseFilteredCompany() {
        const tab = this.$refs["companiesTable"] as any;
        if(tab.filteredItems.length === 1) {
            const orgnum = tab.filteredItems[0].orgNum;
            if(orgnum > 0) {
                this.chooseCompany(orgnum);
            }
        }
    }

    async loadUserCompanies() {
        // XXX use this.baseApi.user.companyRelations instead?
        this.userCompanies = await this.api.fetchRoleCompanies();
    }

    get accountInitTo() {
        return {name: rd.company.init.name};
    }

    account: CompanyAccount | null = null;

    @Watch("company", {immediate: true})
    async loadCompanyAccount() {
        if(this.company != null) {
            this.account = await this.api.getCompanyAccount(this.company.orgNum);
        } else {
            this.account = null;
        }
    }

    get hasFree() {
        return this.account && this.account.freeUntilTs.isAfter(DateTime.now());
    }

    async reduceInvoiceException() {
        if(this.company) {
            await this.api.reduceCompanyInvoiceException(this.company.orgNum);
            await this.loadCompanyAccount();
            this.emitSnack("Gratis demo nedjustert, evt eksisterende Demoperiode fritak på anlegg oppdatert", "success");
        }
    }
    async increaseInvoiceException() {
        if(this.company) {
            await this.api.increaseCompanyInvoiceException(this.company.orgNum);
            await this.loadCompanyAccount();
            this.emitSnack("Gratis demo oppjustert, evt eksisterende Demoperiode fritak på anlegg oppdatert", "success");
        }
    }

    get shouldShowAccountInit() {
        // #AppleCompliance
        // Account init nav link must be hidden when in iOS app to comply with Apple guidelines/avoid app being blocked.
        if(this.company != null) {
            if (this.user.isCompanyAdmin(this.company.orgNum) || this.user.isCompanySuper(this.company.orgNum)) {
                return true;
            }
        }
        return !hasIosAppInterface();
    }

    created() {
        this.loadUserCompanies();
    }
}
